import { IConfig } from "./configTypes";

const env = (import.meta as any).env;

export const config: IConfig = {
	mode: env.MODE || "production",
	themeName: env.VITE_THEME_NAME,
	appStoreLink: env.VITE_APP_STORE_LINK,
	playStoreLink: env.VITE_PLAY_STORE_LINK,
};
